const breadCrumb = "Rendimento - Rendimento";

const routes = [
  {
    path: "/gerar-rendimento",
    name: "gerar-rendimento",
    meta: {
      requireAuth: false,
      allowedPermissions: ["fechamento_carga_list"],
      breadCrumb: breadCrumb,
    },
    component: () =>
      import("@/views/Rendimento/GerarRendimento/GerarRendimentoHome.vue"),
  },
];

export default routes;
